import { TableHeader, Total, GridBox, Grid, TableHead, TableHeadRow, TopRow } from 'libs/ui';
import Row from './Row';

import { useTranslation } from 'react-i18next';

const BenefitsGrid = (props) => {
  const { t } = useTranslation();

  const getBenefitsList = () => {
    const benefits = props.entries || props.rides;
    let benefitsList = [];
    if (benefits) {
      for (let key in benefits) {
        benefitsList.push(<Row zones={props.zones} key={benefits[key].id} {...benefits[key]} />);
      }
    }
    return benefitsList;
  };

  return (
    <GridBox>
      <TopRow>
        <Total cnt={props.count} />
        {props.getXlsLink()}
      </TopRow>
      <Grid>
        <TableHead>
          <TableHeadRow>
            {window.config.central && <TableHeader width="90px">{t('grid.Парковка')}</TableHeader>}
            <TableHeader width="220px" sortField="created_at">
              {t('grid.Дата и время')}
            </TableHeader>
            <TableHeader width="240px" sortField="name">
              {t('form.Клиент')}
            </TableHeader>
            <TableHeader sortField="amount">{t('grid.Сумма')}</TableHeader>
            <TableHeader width="220px" sortField="amount_used">
              {t('grid.Фактическая скидка')}
            </TableHeader>
            <TableHeader width="240px" sortField="fn">
              {t('form.Номер ФН')}
            </TableHeader>
          </TableHeadRow>
        </TableHead>
        <tbody>{getBenefitsList()}</tbody>
      </Grid>
    </GridBox>
  );
};

export default BenefitsGrid;
